import { getSnapIntervalHeight } from '../constants/dragDrop';
import memoizeOne from 'react-utils/memoizeOne';
const HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
export const getEventDurationInHours = memoizeOne((start, end) => Math.floor((end - start) / HOUR_IN_MILLISECONDS));
export const getEventHeight = memoizeOne((start, end, hourHeight) => {
  return hourHeight * getEventDurationInHours(start, end);
});
export function getClosestSnapPoint({
  containerRef,
  monitor,
  eventDurationInHours,
  hourHeight
}) {
  var _containerRef$current, _containerRef$current2;
  const offsetY = monitor.getClientOffset().y - ((_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.getBoundingClientRect().top) !== null && _containerRef$current !== void 0 ? _containerRef$current : 0);

  // snap points go from 0 to 23 with fixed snap points of 1h length
  return Math.min(Math.max(Math.round(offsetY / getSnapIntervalHeight(hourHeight)) - 1, 0), 24 - eventDurationInHours);
}